import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCrown, faTimes, faCheck, faRocket } from '@fortawesome/free-solid-svg-icons';

const PremiumUpgradeModal = ({ onClose }) => {
  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.85)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 2000,
      padding: '1rem'
    }}>
      <div style={{
        backgroundColor: '#1a1a1a',
        borderRadius: '16px',
        maxWidth: '600px',
        width: '100%',
        border: '2px solid #FFB6C1',
        boxShadow: '0 20px 60px rgba(255, 182, 193, 0.3)',
        position: 'relative',
        overflow: 'hidden'
      }}>
        {/* Premium Badge Decoration */}
        <div style={{
          position: 'absolute',
          top: '-50px',
          right: '-50px',
          width: '150px',
          height: '150px',
          background: 'linear-gradient(135deg, #FFB6C1 0%, #FF69B4 100%)',
          borderRadius: '50%',
          opacity: 0.1
        }} />

        {/* Close Button */}
        <button
          onClick={onClose}
          style={{
            position: 'absolute',
            top: '1rem',
            right: '1rem',
            background: 'none',
            border: 'none',
            color: '#999',
            fontSize: '1.5rem',
            cursor: 'pointer',
            zIndex: 1,
            transition: 'color 0.2s'
          }}
          onMouseEnter={(e) => e.currentTarget.style.color = '#FFB6C1'}
          onMouseLeave={(e) => e.currentTarget.style.color = '#999'}
        >
          <FontAwesomeIcon icon={faTimes} />
        </button>

        {/* Content */}
        <div style={{ padding: '3rem 2rem 2rem 2rem' }}>
          {/* Header */}
          <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
            <div style={{
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: '80px',
              height: '80px',
              borderRadius: '50%',
              background: 'linear-gradient(135deg, #FFB6C1 0%, #FF69B4 100%)',
              marginBottom: '1rem',
              animation: 'pulse 2s infinite'
            }}>
              <FontAwesomeIcon icon={faCrown} style={{ fontSize: '2.5rem', color: '#fff' }} />
            </div>
            <h2 style={{
              color: '#FFB6C1',
              fontSize: '2rem',
              marginBottom: '0.5rem',
              fontWeight: '700'
            }}>
              Upgrade to Premium
            </h2>
            <p style={{ color: '#999', fontSize: '1.1rem' }}>
              Unlock the full power of Buddy Sessions
            </p>
          </div>

          {/* Features List */}
          <div style={{
            backgroundColor: 'rgba(0, 0, 0, 0.3)',
            borderRadius: '12px',
            padding: '1.5rem',
            marginBottom: '2rem'
          }}>
            <h3 style={{
              color: '#fff',
              fontSize: '1.2rem',
              marginBottom: '1rem',
              fontWeight: '600'
            }}>
              Premium Benefits:
            </h3>
            <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
              {[
                'Book unlimited buddy sessions',
                'Priority facilitator matching',
                'Advanced session scheduling',
                'Extended session duration',
                'Personalized support plans',
                'Access to premium resources'
              ].map((feature, index) => (
                <li key={index} style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '1rem',
                  padding: '0.75rem 0',
                  color: '#fff',
                  fontSize: '1rem'
                }}>
                  <FontAwesomeIcon 
                    icon={faCheck} 
                    style={{ 
                      color: '#FFB6C1',
                      fontSize: '1.2rem',
                      flexShrink: 0
                    }} 
                  />
                  <span>{feature}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* CTA Section */}
          <div style={{
            textAlign: 'center',
            backgroundColor: 'rgba(255, 182, 193, 0.05)',
            borderRadius: '12px',
            padding: '1.5rem',
            border: '1px solid rgba(255, 182, 193, 0.2)'
          }}>
            <p style={{
              color: '#FFB6C1',
              fontSize: '1.5rem',
              fontWeight: '700',
              marginBottom: '0.5rem'
            }}>
              Start Your Premium Journey
            </p>
            <p style={{
              color: '#999',
              fontSize: '0.95rem',
              marginBottom: '1.5rem'
            }}>
              Contact us to learn more about premium plans
            </p>
            
            <div style={{ display: 'flex', gap: '1rem', justifyContent: 'center', flexWrap: 'wrap' }}>
              <a
                href="mailto:info@bestieconnect.com?subject=Premium Upgrade Inquiry"
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '0.5rem',
                  padding: '1rem 2rem',
                  background: 'linear-gradient(135deg, #FFB6C1 0%, #FF69B4 100%)',
                  color: '#fff',
                  textDecoration: 'none',
                  borderRadius: '8px',
                  fontSize: '1rem',
                  fontWeight: '600',
                  cursor: 'pointer',
                  transition: 'transform 0.2s, box-shadow 0.2s',
                  border: 'none'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-2px)';
                  e.currentTarget.style.boxShadow = '0 8px 24px rgba(255, 182, 193, 0.4)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = 'none';
                }}
              >
                <FontAwesomeIcon icon={faRocket} />
                Contact Us to Upgrade
              </a>
              
              <button
                onClick={onClose}
                style={{
                  padding: '1rem 2rem',
                  backgroundColor: 'transparent',
                  color: '#999',
                  border: '1px solid #333',
                  borderRadius: '8px',
                  fontSize: '1rem',
                  fontWeight: '600',
                  cursor: 'pointer',
                  transition: 'all 0.2s'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.05)';
                  e.currentTarget.style.borderColor = '#666';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = 'transparent';
                  e.currentTarget.style.borderColor = '#333';
                }}
              >
                Maybe Later
              </button>
            </div>
          </div>
        </div>
      </div>

      <style>
        {`
          @keyframes pulse {
            0%, 100% {
              transform: scale(1);
            }
            50% {
              transform: scale(1.05);
            }
          }
        `}
      </style>
    </div>
  );
};

export default PremiumUpgradeModal;
